var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.575736 0.325736C0.81005 0.0914214 1.18995 0.0914214 1.42426 0.325736L6.67426 5.57574C6.90858 5.81005 6.90858 6.18995 6.67426 6.42426L1.42426 11.6743C1.18995 11.9086 0.81005 11.9086 0.575736 11.6743C0.341421 11.4399 0.341421 11.0601 0.575736 10.8257L5.40147 6L0.575736 1.17426C0.341421 0.93995 0.341421 0.560051 0.575736 0.325736Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.3dde42395d32a1edd90e8d5fc917fccc.svg";
export { ForwardRef as ReactComponent };